<template lang="html">
  <div class="body-login">
    <div class="wrapper fadeInDown">
      <div class="fadeIn first">
        <img src="@/assets/macurco-logo.png" class="login-logo" />
      </div>
      <div id="formContent">
        <h4>{{ $t("settings.newPassword") }}</h4>
        <form @submit="onSubmit($event)">
          <McPassword v-model="password" g-class="login-input"/>
          <p class="password-helper">Your password must contain an uppercase letter, a lowercase letter, and a special character.</p>
          <button class="btn btn-primary mt-3" :disabled="loading || !passwordIsValid">
            <span class="spinner-border spinner-border-sm" v-show="loading" />
            {{ $t("button.send") }}
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import McPassword from "@/components/McPassword/McPassword.vue";
import { recoverPassword } from "@/api/index";

export default {
  name: "Forgot",
  components: {
    McPassword,
  },
  data() {
    return {
      password: "",
      loading: false,
    };
  },
  computed: {
    passwordIsValid() {
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=.*[0-9]).{8,}$/;
      return regex.test(this.password);
    },
  },
  methods: {
    onSubmit(e) {
      e.preventDefault();
      this.loading = true;
      recoverPassword(this.$router.currentRoute.params.token, this.password)
        .then((res) => {
          this.loading = false;
          console.warn(res);
          this.$router.push("/login");
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    const token = localStorage.getItem('jwt');
    console.log('Token', token);
    if (token !== null && token !== '') {
      localStorage.removeItem('jwt');
      localStorage.removeItem('vuex');
      window.location.reload();
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./login.scss";
</style>
